import theme from 'Theme';
export default {
  link : {
    textDecoration : "none",
    color : theme.white,
  },
  redirectBtn : {
    marginTop : "40px",
    width : "150px",
    borderRadius : 24,
    color : theme.white,
    fontFamily: theme.bodyFont,
    background: "#153862",
    fontSize : "12px",
    lineHeight : "30px",
    textAlign : "center",
    padding : "8px 15px",
    textTransform : "none",
    border : "1px solid #FFFFFF",
    textDecoration : "none",
    "&:hover": {
      background: "#153862",
    },
    "@media(min-width: 768px)": {
      width : "200px",
      marginTop : "20px",
    }
  },
  signUpNewLink : {
    marginTop : "5px",
    fontSize : "14px",
    lineHeight : "22px",
    '& a' : {
      cursor : "pointer",
      color: "inherit",
      textDecoration: "underline",
    }
  },
  loading : {
    minHeight : "100px",
    display : "flex",
    alignItems : "center"
  },
  noHyper: {
    textDecoration: "none",
    outline : "0",
  }
}



// WEBPACK FOOTER //
// ./src/components/SignUpSuccessContainer/SignUpSuccess/RedirectBtn/redirectBtn.style.js